module.exports = __webpack_public_path__ + "preloader-bg.77b48789.png";